<section class="container py-5 lg:py-8">
  <div class="col-span-12" [innerHtml]="section.content | safeHtml"></div>
</section>
